import { forwardRef, memo, useCallback, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card, Image, Carousel } from 'react-bootstrap';
import { ContentPreview } from '../ContentPreview/ContentPreview';
import TextEditor from '../../../BBCodeEditor/BBCodeEditor';
import { DndIcon } from '../../../../shared/icons/Dnd';

const ContentItem = forwardRef(
  ({ data, onChangeFile, onChangeSlider, onDelete, onDragElement, ...props }, ref) => {
    useEffect(() => {
      console.log(data);
    }, [data]);

    if (!data) return null;
    return (
      <Card 
        id={`content-item-${data.id}`} 
        className="dnd-element mb-3" 
        {...props} 
        ref={ref}>
        <Card.Body>
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-4 align-items-center mb-2">
                  <DndIcon style={{ marginTop: '-5px' }} {...onDragElement} />
                  <h5>{`Элемент: ${data.label}`}</h5>
                </div>
                <Button onClick={() => onDelete(data.id)} variant="danger" size="sm">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.0001 0H6.10352e-05V3C1.10463 3 2.00006 3.89543 2.00006 5V9C2.00006 11.8284 2.00006 13.2426 2.87874 14.1213C3.75742 15 5.17163 15 8.00006 15H10.0001C12.8285 15 14.2427 15 15.1214 14.1213C16.0001 13.2426 16.0001 11.8284 16.0001 9V5C16.0001 3.89543 16.8955 3 18.0001 3V0ZM7.50006 5C7.50006 4.44772 7.05235 4 6.50006 4C5.94778 4 5.50006 4.44772 5.50006 5V10C5.50006 10.5523 5.94778 11 6.50006 11C7.05235 11 7.50006 10.5523 7.50006 10V5ZM12.5001 5C12.5001 4.44772 12.0523 4 11.5001 4C10.9478 4 10.5001 4.44772 10.5001 5V10C10.5001 10.5523 10.9478 11 11.5001 11C12.0523 11 12.5001 10.5523 12.5001 10V5Z"
                      fill="rgb(225, 96, 112)"
                    />
                  </svg>
                </Button>
              </div>

              {data.type === 'ImageContentItem' && (
                <Form.Group>
                  <Form.Label>Загрузите изображение</Form.Label>
                  <Form.Control
                    type="file"
                    size="sm"
                    accept="image/*"
                    onChange={(e) => onChangeFile(data.id, e.target.files[0])}
                  />
                  {data.content && <ContentPreview data={data} />}
                </Form.Group>
              )}
              {data.type === 'AudioContentItem' && (
                <Form.Group>
                  <Form.Label>Загрузите аудио</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/*"
                    size="sm"
                    onChange={(e) => onChangeFile(data.id, e.target.files[0])}
                  />
                  {data.content && <ContentPreview type={data.type} data={data.content} />}
                </Form.Group>
              )}
              {data.type === 'VideoContentItem' && (
                <Form.Group>
                  <Form.Label>Загрузите видео</Form.Label>
                  <Form.Control
                    type="file"
                    size="sm"
                    accept="video/*"
                    onChange={(e) => onChangeFile(data.id, e.target.files[0])}
                  />
                  {data.content && <ContentPreview type={data.type} data={data.content} />}
                </Form.Group>
              )}
              {data.type === 'ImageSliderContentItem' && (
                <Form.Group>
                  <Form.Label>Загрузите несколько изображений</Form.Label>
                  <Form.Control
                    type="file"
                    size="sm"
                    accept="image/*"
                    multiple
                    onChange={(e) => onChangeSlider(data.id, e.target.files)}
                  />
                  {data.content?.length > 0 && <ContentPreview data={data.content} />}
                </Form.Group>
              )}
              {data.type === 'TextContentItem' && (
                <TextEditor
                  value={data.content}
                  setValue={(value) => onChangeFile(data.id, value)}
                />
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  },
);

export default memo(ContentItem);
